import { controls, grouped } from "../controls";
const npa_inspections = {
  label: "NPA Inspections",
  pageLabel: "NPA Inspections", starting: true, url: "autogen",
  submitLogic: { allowPartialSubmit: true, doubleConfirm: 'irreversible', submitText: 'finalsubmit', },
  formActions: { edit: { allow: true }, delete: { allow: false } },
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Client" }),
    ...controls.oc({ tab: "filter", c: "Client", placeHolder: "Client Code", name: "NPAInspection-client-client_code", fastpath: "clients" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "NPAInspection-client-client_display" }),
    ...controls.displayText({ tab: "filter", label: "Branch" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Branch", placeHolder: "Branch Code", name: "NPAInspection-branch-branch_code", fastpath: "branches" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "NPAInspection-branch-branch_display" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Branch", star: false, style: { textAlign: 'left' }, width: 'col-sm-1' }),
    ...controls.oc({ tab: "general", length: 4, c: "Branch", placeHolder: "Branch Code", name: "branch_code", fastpath: "branches", isReadOnly: "edit", hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "branch_display" }),
    ...controls.checkBox({ tab: "general", label: "Final Submit", default: false, name: "acknowledge", width: 'col-sm-6', style: { textAlign: 'right' }, isrequired: true }),
    {
      widths: "col-sm-12",
      tab: "general",
      title: "Npai Observations",
      subComponents: [
        ...controls.displayText({ tab: "general", label: "Name Of Borrower", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "name_of_borrower", width: "col-sm-4", maxlength: 500 }),
        ...controls.magicDateLabel({ tab: "general", label: "Date Of Disbursement", target: "date_of_disbursement", star: false }),
        ...controls.magicDate({ tab: "general", name: "date_of_disbursement", dateType: "ontype", maxDate: '3 months ago' }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Loan Amount" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "loan_amount", maxlength: 18 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Purpose", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "purpose", width: "col-sm-4", maxlength: 500 }),
        ...controls.magicDateLabel({ tab: "general", label: "Date of NPA", target: "date_of_npa", star: false }),
        ...controls.magicDate({ tab: "general", name: "date_of_npa", dateType: "ontype", maxDate: 'n' }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Outstanding" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "outstanding", maxlength: 18 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Overdue With Interest" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "overdue_with_interest", maxlength: 18 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Action Taken By Manager", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "action_taken_by_manager", width: "col-sm-4", maxlength: 500 }),
        ...controls.displayText({ tab: "general", label: "Observation", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "observation", width: "col-sm-4", maxlength: 500 }),

        ...controls.displayText({ tab: "npai_observations", width: "col-sm-12", label: "" }),
        // ...controls.displayText({ tab: "npai_observations", width: "col-sm-4", label: "" }),

        ...controls.button({
          tab: "npai_observations",
          label: "SAMPLE",
          style: { padding: 0 },
          icon: "excel",
          onclick: {
            action: "downloadSample",
            tableNameField: "npai_observations",
            requiredField: ["name_of_borrower", "date_of_disbursement", "loan_amount", "purpose", "date_of_npa", "outstanding", "overdue_with_interest", "action_taken_by_manager", "observation",]
          }, width: "col-sm-2"
        }),

        ...controls.FileUpload({

          readFile: { targetTable: 'npai_observations', type: 'csv', columns: ["name_of_borrower", "date_of_disbursement", "loan_amount", "purpose", "date_of_npa", "outstanding", "overdue_with_interest", "action_taken_by_manager", "observation",] },
          label: "Fileupload",
          name: "bulk_file_upload",
          placeholder: {
            type: "text",
            value: "Upload Bulk files"
          },
          tab: "npai_observations",
          width: "col-sm-8"
        }),

        ...controls.button({
          tab: "npai_observations",
          label: "ADD",
          style: { padding: 0 },
          Bcolor: "success",
          onclick: {
            action: "appendToHTMLTable",
            tableNameField: "npai_observations",
            requiredField: ["name_of_borrower", "date_of_disbursement", "loan_amount", "purpose", "date_of_npa", "outstanding", "overdue_with_interest", "action_taken_by_manager", "observation",]
          }, width: "col-sm-2"
        }),
        // ...controls.button({
        //   tab: "npai_observations",
        //   label: "CLEAR",
        //   style: { padding: 0 },
        //   Bcolor: "warning",
        //   onclick: {
        //     action: "clearForm",
        //     tableNameField: "npai_observations",
        //     requiredField: ["name_of_borrower", "date_of_disbursement", "loan_amount", "purpose", "date_of_npa", "outstanding", "overdue_with_interest", "action_taken_by_manager", "observation",]
        //   }, width: "col-sm-2"
        // }),
        {
          tab: "npai_observations",
          inputType: "table",
          tableTitle: "",
          deletable: true,
          editable: true,
          tableHeaders: [
            { label: "Sr", type: "autoinc" },
            { label: "Name Of Borrower", field: "name_of_borrower" },
            { label: "Date Of Disbursement", field: "date_of_disbursement", displaytype: "date" },
            { label: "Loan Amount", field: "loan_amount" },
            { label: "Purpose", field: "purpose" },
            { label: "Date of NPA", field: "date_of_npa", displaytype: "date" },
            { label: "Outstanding", field: "outstanding" },
            { label: "Overdue With Interest", field: "overdue_with_interest" },
            { label: "Action Taken By Manager", field: "action_taken_by_manager" },
            { label: "Observation", field: "observation" },
          ],
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          name: "npai_observations"
        },
      ]
    },
  ]
  , history: {
    perPage: 10,
    reportHeader: "NPA Inspections",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Client", accessor: "NPAInspection-client-client_display", },
      { Header: "Branch", accessor: "NPAInspection-branch-branch_display", },
      { Header: "Updatedat", accessor: "updatedat", type: 'date' },
    ]
  }
};
export default npa_inspections;